import { motion } from "framer-motion";

export default function BookMockup({ size = "lg" }) {
  const w = size === "lg" ? "w-60 sm:w-72" : "w-44 sm:w-52";
  return (
    <motion.div
      data-testid="book-mockup"
      className={`relative ${w} mx-auto`}
      whileHover={{ y: -8, scale: 1.02 }}
      transition={{ type: "spring", stiffness: 120, damping: 14 }}
    >
      <img
        src="/assets/libro-cover.jpg"
        alt="Copertina del libro Dentro il Calice — Italia di Stefano Cremonese"
        loading="lazy"
        className="w-full h-auto rounded-lg shadow-[0_30px_60px_-15px_rgba(0,0,0,0.6)]"
      />
    </motion.div>
  );
}
